export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavTitle',
        _children: ['Main Menu']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: 'Dashboard',
        icon: {
          src: require('@/assets/img/element-4.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'My Record',
        to: 'MyRecord',
        icon: {
          src: require('@/assets/img/folder-open.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Apply',
        route: '/ApplyLeave',
        icon: {
          src: require('@/assets/img/folder-add.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
        items: [
          {
            name: 'Leave',
            to: 'ApplyLeave',
            icon: {
              src: require('@/assets/img/folder-add.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          {
            name: 'Claim',
            to: 'ApplyClaim',
            icon: {
              src: require('@/assets/img/folder-add.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          {
            name: 'Time Off',
            to: 'ApplyTimeOff',
            icon: {
              src: require('@/assets/img/folder-add.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          {
            name: 'Salary',
            to: 'ApplySalary',
            icon: {
              src: require('@/assets/img/folder-add.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Announcement',
        to: 'Announcement',
        icon: {
          src: require('@/assets/img/volume-high.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Calendar',
        to: 'TeamCalendar',
        icon: {
          src: require('@/assets/img/calendar 2.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Performance',
        to: 'Performance',
        icon: {
          src: require('@/assets/img/chart.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Invite Friends',
      //   to: 'InviteFriend',
      //   icon: {
      //     src: require('@/assets/img/profile-2user1.png'),
      //     width: 15,
      //     height: 15,
      //     class: 'mr-3'
      //   },
      // },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Administration']
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Approval',
        route: '/Approval',
        icon: {
          src: require('@/assets/img/folder-add.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
        items: [
          {
            name: 'Leave',
            to: 'ApprovalLeave',
            icon: {
              src: require('@/assets/img/folder-add.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          {
            name: 'Claim',
            to: 'ApprovalClaim',
            icon: {
              src: require('@/assets/img/folder-add.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          {
            name: 'Time Off',
            to: 'ApprovalTimeOff',
            icon: {
              src: require('@/assets/img/folder-add.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Employee',
        to: 'RegisterStaff',
        icon: {
          src: require('@/assets/img/profile-2user1.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },

      {
        _name: 'CSidebarNavDropdown',
        name: 'Attendance',
        route: '/AttendanceTimesheet',
        icon: {
          src: require('@/assets/img/clock.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
        items: [
          {
            name: 'Timesheet',
            to: 'AttendanceTimesheet',
            icon: {
              src: require('@/assets/img/folder-add.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          {
            name: 'Shift Calendar',
            to: 'ShiftCalendar',
            icon: {
              src: require('@/assets/img/folder-add.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          {
            name: 'Overtime',
            to: '',
            icon: {
              src: require('@/assets/img/folder-add.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          {
            name: 'Lateness',
            to: '',
            icon: {
              src: require('@/assets/img/folder-add.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          
        ]
      },
      
      {
        _name: 'CSidebarNavItem',
        name: 'Yearly Form',
        to: '',
        icon: {
          src: require('@/assets/img/calendar2.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Payment',
        route: '/SalaryPayroll',
        icon: {
          src: require('@/assets/img/clock.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
        items: [
          {
            name: 'Salary Payroll',
            to: 'SalaryPayroll',
            icon: {
              src: require('@/assets/img/folder-add.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          {
            name: 'Payment Voucher',
            to: 'PaymentVoucher',
            icon: {
              src: require('@/assets/img/folder-add.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
        ]
          
      },

      {
        _name: 'CSidebarNavItem',
        name: 'Profile Setting',
        to: 'SettingProfile',
        icon: {
          src: require('@/assets/img/user-tick.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
     
      {
        _name: 'CSidebarNavItem',
        name: 'Setting',
        to: 'Setting',
        icon: {
          src: require('@/assets/img/setting-2.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
     
     
    ]
  },
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Setting',
        to: 'Setting',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Logout',
        to: 'Logout',
      },
    ],
    _style: 'margin-top: auto;', // Pushes the navigation items to the bottom of the sidebar
  }
]